import {Button, Col, notification, Row, Spin, Tooltip} from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import React, {useCallback, useRef, useState} from 'react';
import styled from 'styled-components';
import axios from 'axios';
import {useLocation, useNavigate} from 'react-router-dom';
import {LoadingOutlined} from '@ant-design/icons';
import update from 'immutability-helper';
import {DndProvider, useDrag, useDrop} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import illustration_upload from '../images/illustration_upload.png';
import {StringParam, useQueryParam} from 'use-query-params';

const type = 'DragableUploadList';

const DragableUploadListItem = ({originNode, moveRow, file, fileList}) => {
    const ref = useRef(null);
    const index = fileList.indexOf(file);
    const [{isOver, dropClassName}, drop] = useDrop({
        accept: type,
        collect: monitor => {
            const {index: dragIndex} = monitor.getItem() || {};
            if (dragIndex === index) {
                return {};
            }
            return {
                isOver: monitor.isOver(),
                dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
            };
        },
        drop: item => {
            moveRow(item.index, index);
        },
    });
    const [, drag] = useDrag({
        type,
        item: {
            index,
        },
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    });
    drop(drag(ref));
    const errorNode = <Tooltip title="Upload Error">{originNode.props.children}</Tooltip>;
    return (
        <div
            ref={ref}
            className={`ant-upload-draggable-list-item ${isOver ? dropClassName : ''}`}
            style={{
                cursor: 'move',
            }}>
            {file.status === 'error' ? errorNode : originNode}
        </div>
    );
};
const UploadFiles = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [claimType] = useQueryParam('type', StringParam);
    const [listFile, setListFile] = useState([]);
    const [loading, setLoading] = useState(false);
    const antIcon = (
        <LoadingOutlined
            style={{
                fontSize: 24,
                color: 'white',
            }}
            spin
        />
    );

    const handleSubmit = () => {
        const formData = new FormData();
        setLoading(true);
        listFile.map(e => {
            formData.append('files', e.originFileObj);
        });

        formData.append('claim_type', claimType);
        
        const options = {
            method: 'POST',
            params : {
                check_missing: true
            },
            data: formData,
            // url: `https://dev.docbase.ai/api/v1/folders/${process.env.REACT_APP_FOLDER_ID}/images`,
            url: `https://tpa.docbase.ai/api/v1/documents/classify`
            // url: `http://192.168.1.122:8002/api/v1/documents/classify`
        };
        axios(options)
            .then(res => {
                setLoading(false);
                navigate(`/upload-success${location.search}`, {
                    state: {
                        data: res.data,
                        files: listFile,
                    }
                    ,
                });
            })
            .catch(error => {
                setLoading(false);
                notification.error({
                    message: error.message,
                });
            });
        // navigate(`/upload-success${location.search}`);
    };

    const moveRow = useCallback(
        (dragIndex, hoverIndex) => {
            const dragRow = listFile[dragIndex];
            setListFile(
                update(listFile, {
                    $splice: [
                        [dragIndex, 1],
                        [hoverIndex, 0, dragRow],
                    ],
                }),
            );
        },
        [listFile],
    );
    const onChange = e => {
        setListFile(e.fileList);
    };

    return (
        <UploadFilesWrapper>
            <Row>
                <Col xs={24}>
                    <Container>
                        <Text>Tải lên hồ sơ</Text>
                        <DndProvider backend={HTML5Backend}>
                            <Dragger
                                name="file"
                                accept=".png,.jpg,.jpeg,.pdf"
                                multiple
                                beforeUpload={() => {
                                    return false;
                                }}
                                fileList={listFile}
                                listType="picture"
                                onChange={onChange}
                                itemRender={(originNode, file, currFileList) => (
                                    <DragableUploadListItem
                                        originNode={originNode}
                                        file={file}
                                        fileList={currFileList}
                                        moveRow={moveRow}
                                    />
                                )}>
                                <ImageUpLoad src={illustration_upload} />
                                <ChooseFile>
                                    <TextUploadContainer>Chọn file</TextUploadContainer>
                                    <TitleUploadContainer>
                                        Kéo và thả file vào đây hoặc{' '}
                                        <button
                                            style={{
                                                border: 'none',
                                                padding: '0px',
                                                background: '#f4f6f8',
                                                color: '#ec1c2b',
                                                textDecoration: 'underLine',
                                                cursor: 'pointer',
                                            }}>
                                            Tải lên
                                        </button>{' '}
                                        từ thiết bị của bạn
                                    </TitleUploadContainer>           
                                </ChooseFile>
                            </Dragger>
                        </DndProvider>
                        <WrapBtn>
                            <Button className="btnBack" style={{marginLeft: '8px'}} onClick={() => navigate(-1)}>
                                ← Quay lại
                            </Button>
                            {listFile?.length === 0 ?
                                <Tooltip title="Vui lòng chọn file" >
                                    <span>
                                        <Button
                                            className="btnSubmit"
                                            type="primary"
                                            onClick={handleSubmit}
                                            disabled={listFile?.length === 0 ? true : false}
                                            >
                                            {loading ? <Spin indicator={antIcon} /> : 'Tải lên'}
                                        </Button>
                                    </span>
                                </Tooltip > :
                                    <Button
                                        className="btnSubmit"
                                        type="primary"
                                        onClick={handleSubmit}
                                        >
                                        {loading ? <Spin indicator={antIcon} /> : 'Tải lên'}
                                    </Button>
                                }
                        </WrapBtn>
                    </Container>
                </Col>
            </Row>
        </UploadFilesWrapper>
    );
};
export default UploadFiles;
const UploadFilesWrapper = styled.div`
    height: 100%;
    background: #f9fafb;
`;

const Container = styled.div`
    width: 800px;
    height: auto;
    margin: 60px auto 0px auto;
    padding: 40px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    @media screen and (min-width: 1024px) and (max-width: 1199px) {
        width: auto;
        height: auto;
        margin: 124px 40px 0px 40px;
    }
    @media screen and (min-width: 740px) and (max-width: 1023px) {
        width: auto;
        margin: 124px 30px 0px 30px;
    }
    @media screen and (max-width: 739px) {
        width: auto;
        margin: 40px 20px 0px 20px;
    }
`;
const Text = styled.h4`
    height: 39px;
    font-weight: 600;
    font-size: 28px;
    line-height: 140%;
    margin-bottom: 24px;
    color: rgba(0, 0, 0, 0.85);
`;

const ImageUpLoad = styled.img`
    width: 212px;
    height: 160px;
    margin: 40px 0px 40px 28px;
    @media screen and (max-width: 739px) {
        margin: 0px;
    }
`;
const TextUploadContainer = styled.h4`
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #212b36;
    margin: 0px;
    @media screen and (max-width: 739px) {
        text-align: center;
    }
`;
const TitleUploadContainer = styled.span`
    font-weight: 400;
    font-size: 13px;
    line-height: 22px;
    color: #637381;
    @media screen and (max-width: 739px) {
        font-size: 12px;
        text-align: center;
    }
`;
const ChooseFile = styled.div`
    padding: 0px;
    gap: 8px;
    width: 345px;
    height: 60px;
    margin-right: 28px;
    @media screen and (max-width: 739px) {
        margin: 0px;
        display: flex;
        flex-direction: column;
        width: auto;
        height: auto;
    }
`;
const WrapBtn = styled.div`
    display: flex;
    margin-top: 26px;
    width: calc(100% - 128px);
    justify-content: space-between;

    @media screen and (max-width: 739px) {
        display: flex;
        justify-content: space-around;
        width: 100%;
    }
`;
